<template>
  <PagePost v-if="post" :post="post" />
</template>

<script setup lang="ts">
import type { Pages } from "~/@types/pages"
import { getBySlug } from "~/groq/pages"

const route = useRoute()

const { data: post } = await useSanityQuery<Pages>(getBySlug(), {
  slug: route.params.slug,
})

if (!post.value || isEmpty(post.value)) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page not found",
  })
}
</script>
